<template>
  <div class="mb-6 rounded-lg border border-gray-200 bg-white p-4 shadow-xs">
    <ol class="flex items-center">
      <template v-for="(step, idx) in stepsWithStatus" :key="step.key">
        <li class="flex items-center">
          <button
            type="button"
            class="group flex items-center text-left disabled:cursor-not-allowed"
            :disabled="!step.canNavigate"
            @click="step.canNavigate && $emit('go-to-step', idx)"
          >
            <span
              class="flex h-8 w-8 items-center justify-center rounded-full border text-xs font-semibold transition-colors"
              :class="circleClass(step)"
            >
              {{ circleText(step, idx) }}
            </span>
            <span class="ml-2 text-xs font-semibold truncate" :class="labelClass(step)">
              {{ step.label }}
            </span>
          </button>
        </li>
        <div
          v-if="idx < stepsWithStatus.length - 1"
          class="mx-2 h-0.5 flex-1 rounded-sm"
          :class="connectorClass(step)"
        />
      </template>
    </ol>
  </div>
</template>

<script>
export default {
  name: "StoreOnboardingProgressBar",
  props: {
    steps: { type: Array, required: true },
    currentStepIndex: { type: Number, required: true },
    maxReachableStepIndex: { type: Number, required: true },
  },
  emits: ["go-to-step"],
  computed: {
    stepsWithStatus() {
      return this.steps.map((step, idx) => {
        let status;
        if (idx < this.currentStepIndex) status = "complete";
        else if (idx === this.currentStepIndex) status = "current";
        else status = "upcoming";

        return {
          ...step,
          status,
          canNavigate: idx <= this.maxReachableStepIndex && idx !== this.currentStepIndex,
        };
      });
    },
  },
  methods: {
    circleText(step, idx) {
      return step.status === "complete" ? "\u2713" : idx + 1;
    },
    circleClass(step) {
      switch (step.status) {
        case "complete":
          return "border-gray-900 bg-gray-900 text-white";
        case "current":
          return "border-gray-900 bg-white text-gray-900";
        default:
          return "border-gray-300 bg-white text-gray-700";
      }
    },
    labelClass(step) {
      switch (step.status) {
        case "complete":
        case "current":
          return "text-gray-900";
        default:
          return "text-gray-500";
      }
    },
    connectorClass(step) {
      return step.status === "complete" ? "bg-gray-900" : "bg-gray-200";
    },
  },
};
</script>
